import { fmtSEK } from "./format";

export default function RevenueSummary({ summary }) {
  const kpis = [
    { label: "Expected Total Sales", value: summary.expected_total_sales, strong: true, testId: "summary-total-sales" },
    { label: "Time & Material", value: summary.tm_fy, testId: "summary-tm" },
    { label: "Projects", value: summary.projects_fy, testId: "summary-projects" },
    { label: "Services", value: summary.services_fy, testId: "summary-services" },
    { label: "Other Revenue", value: summary.other_fy, testId: "summary-other" },
    { label: "Actual YTD", value: summary.has_closed_months ? summary.ytd_actual : null, testId: "summary-ytd" },
    { label: "Forecast Remaining", value: summary.has_closed_months ? summary.forecast_remaining : null, testId: "summary-remaining" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3 mb-4" data-testid="rev-summary">
      {kpis.map((kpi) => (
        <div
          key={kpi.label}
          className={`rounded-lg border p-3 ${kpi.strong ? "bg-[#0052CC] border-[#0052CC]" : "bg-white border-slate-200"}`}
          data-testid={kpi.testId}
        >
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${kpi.strong ? "text-blue-100" : "text-slate-500"}`}>
            {kpi.label}
          </div>
          <div className={`text-lg font-bold mt-0.5 ${kpi.strong ? "text-white" : "text-slate-900"}`}>
            {kpi.value == null ? "N/A" : `${fmtSEK(kpi.value)} kr`}
          </div>
        </div>
      ))}
    </div>
  );
}
